import {getState, setForm, updateForm, formsSelector} from '../store.js'
import {showGlobalError} from '../ordoro/GlobalErrorMessage.js'
import {getProductKitGraph} from './products.js'

export const DIRECT_KIT_PARENTS = 'direct_kit_parents'
export const DIRECT_BOM_PARENTS = 'direct_bom_parents'

export function setDirectKitParents(sku, directKitParents) {
  if (formsSelector(getState())[DIRECT_KIT_PARENTS]) {
    updateForm(DIRECT_KIT_PARENTS, {[sku]: directKitParents})
  } else {
    setForm(DIRECT_KIT_PARENTS, {[sku]: directKitParents})
  }
}

export function directKitParentsAllSelector(state) {
  return (
    formsSelector(state)[DIRECT_KIT_PARENTS] ||
    directKitParentsAllSelector.default
  )
}
directKitParentsAllSelector.default = {}

export function directKitParentsSelector(state, {sku}) {
  return (
    directKitParentsAllSelector(state)[sku] || directKitParentsSelector.default
  )
}
directKitParentsSelector.default = []

export function isKitComponentSelector(state, {sku}) {
  return directKitParentsSelector(state, {sku}).length > 0
}

export function directKitParentsHaveLoadedSelector(state, {sku}) {
  return !!directKitParentsAllSelector(state)[sku]
}

export function setDirectBOMParents(sku, directBOMParents) {
  if (formsSelector(getState())[DIRECT_BOM_PARENTS]) {
    updateForm(DIRECT_BOM_PARENTS, {[sku]: directBOMParents})
  } else {
    setForm(DIRECT_BOM_PARENTS, {[sku]: directBOMParents})
  }
}

export function directBOMParentsAllSelector(state) {
  return (
    formsSelector(state)[DIRECT_BOM_PARENTS] ||
    directBOMParentsAllSelector.default
  )
}
directBOMParentsAllSelector.default = {}

export function directBOMParentsSelector(state, {sku}) {
  return (
    directBOMParentsAllSelector(state)[sku] || directBOMParentsSelector.default
  )
}
directBOMParentsSelector.default = []

export function isBOMComponentSelector(state, {sku}) {
  return directBOMParentsSelector(state, {sku}).length > 0
}

export function directBOMParentsHaveLoadedSelector(state, {sku}) {
  return !!directBOMParentsAllSelector(state)[sku]
}

export async function getDirectParents(sku) {
  try {
    const kitGraph = await getProductKitGraph(sku, {
      components_type: 'direct_ancestors_only',
      translate_bom_skus: true,
    })

    const [directKitParents, directBOMParents] = kitGraph.edges
      .map(({source: parent_sku, weight}) => ({
        ...kitGraph.nodes.find(({id}) => id === parent_sku),
        quantityInParent: weight,
      }))
      .reduce(
        (prev, node) => {
          if (node.product_type === 'bom') {
            prev[1].push(node)
          } else if (node.product_type === 'product') {
            prev[0].push(node)
          }
          return prev
        },
        [[], []],
      )

    setDirectKitParents(sku, directKitParents)
    setDirectBOMParents(sku, directBOMParents)
  } catch (err) {
    showGlobalError(
      {
        summary: `Error getting kit graph for ${sku}.`,
        details: err.error_message || err.message,
      },
      err,
    )
  }
}
